import React, { useMemo } from "react";
import { IBranch } from "../../interfaces";
import CustomSelect from "./CustomSelect/CustomSelect";

interface BranchSelectProps {
  branches: IBranch[];
  selectedBranch: string;
  onChange: (value: string) => void;
}

const BranchSelect: React.FC<BranchSelectProps> = ({
  branches,
  selectedBranch,
  onChange,
}) => {
  const options = useMemo(
    () => branches.map((b) => ({ value: b.city_id, label: b.city_name })),
    [branches]
  );
  return (
    <CustomSelect
      id="city_id"
      label="Город"
      placeholder="Выберите город"
      options={options}
      value={selectedBranch}
      onChange={onChange}
    />
  );
};

export default BranchSelect;
